import React, { useContext } from "react";
import { Button } from "react-bootstrap";
import { AppContext } from "../../AppContext";

export default function Account({ isMobile }) {
    const { user } = useContext(AppContext);

    // Logout is a server route (session redirect), so it needs a full-page navigation. In dev
    // the client (8080) and backend (54306) are separate origins; in production the build is
    // served from the same origin, so a relative path works.
    const logoutDomain = process.env.NODE_ENV === "development" ? (process.env.REACT_APP_API_ORIGIN ?? "http://localhost:54306") : "";
    const logoutRoute = `${logoutDomain}/api/auth/logout`;

    const cardStyle = {
        background: "white",
        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
        borderRadius: "10px",
        width: isMobile ? "90%" : "50%",
        margin: "auto",
        marginTop: isMobile ? "0px" : "10px",
        padding: "20px"
    };

    return (
        <div dir="rtl" style={cardStyle}>
            <h5 style={{ marginBottom: "15px" }}>חשבון</h5>
            {user?.email && (
                <p style={{ color: "#555", marginBottom: "8px" }}>
                    מחובר כ: <strong>{user.email}</strong>
                </p>
            )}
            {user?.customer && (
                <p style={{ color: "#555", marginBottom: "20px" }}>
                    לקוח: <strong>{user.customer}</strong>
                </p>
            )}
            <Button variant="outline-danger" onClick={() => { window.location.href = logoutRoute; }}>
                התנתקות
            </Button>
        </div>
    );
}
